import { Injectable } from '@angular/core';
import { IProfile } from '@interfaces/index';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  isSuperSuperAdmin(profile: IProfile | null | undefined): boolean {
    return profile?.role_name === 'Super Admin' && !!profile?.admin_org;
  }
}
